export default __webpack_public_path__ + "static/media/lava-ui-tablet-side.f85cfa9f.webp";